import React from 'react';

import { bemBlock, Text } from '@neptune/shared/venus-ui';

import { ExperimentState } from 'domain/experiment/experiment-state';

import { UnifiedExperimentStateIcon } from './experiment-state-icon/UnifiedExperimentStateIcon';

import './ExperimentStateLabel.less';

export type ExperimentStateLabelProps = {
  label: React.ReactNode;
  small?: boolean;
  state?: ExperimentState;
};

const block = bemBlock('experiment-state-label');

export const ExperimentStateLabel: React.FC<
  ExperimentStateLabelProps & Pick<React.ComponentProps<typeof Text>, 'fontWeight'>
> = ({ label, state, fontWeight = 'semibold' }) => {
  return (
    <Text className={block()} wordBreak="keep-all">
      <UnifiedExperimentStateIcon state={state} />
      {state && ' '}
      <Text fontWeight={fontWeight}>{label}</Text>
    </Text>
  );
};
